export default __webpack_public_path__ + "static/media/contrib.f7d31f9e.svg";